export const COLUMNS_LOCAL_STORAGE_KEY = 'settlementsRelatedTransactionsColumns';
